import forbiddenModule from './forbidden/forbidden';
import unauthorized from './unauthorized/unauthorized';
import notfound from './notfound/notfound';

import './errors.styl';

const errorsModule = angular
  .module('errors', [
    forbiddenModule.name,
    unauthorized.name,
    notfound.name
  ]);

export default errorsModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/errors/errors.js
 **/